import Vue from 'vue'
import Router from 'vue-router'
import Container from '@/components/Container'
import TOS from '@/components/Terms'
import PP from '@/components/Privacy'
import Login from '@/components/Login'
import Register from '@/components/Register'

import Home from '@/components/Home'
import Check from '@/components/Check'
import Dashboard from '@/components/Dashboard'
import Chat from '@/components/Chat'
import ChatMember from '@/components/ChatMember'
import ChatMessage from '@/components/ChatMessage'
import ChatMessageHistory from '@/components/ChatMessageHistory'
import RoutineSelf from '@/components/RoutineSelf'
import RoutineSelfDetail from '@/components/RoutineSelfDetail'
import Services from '@/components/Services'
import Service from '@/components/Service'
import Groups from '@/components/Groups'
import Group from '@/components/Group'
import Users from '@/components/Users'
import User from '@/components/User'
import Routines from '@/components/Routines'
import Routine from '@/components/Routine'
import RoutineRef from '@/components/RoutineRef'
import RoutineGroup from '@/components/RoutineGroup'
import Profile from '@/components/Profile'
import Settings from '@/components/Settings'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home',
      component: Container,
      children: [
        {
          path: 'home',
          name: '目的・目標',
          component: Home
        },
        {
          path: 'check',
          name: 'ルーティンチェック表',
          component: Check
        },
        {
          path: 'dashboard',
          name: 'ダッシュボード',
          component: Dashboard
        },
        {
          path: 'chat',
          meta: {label: 'チャット'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Chat
            },
            {
              path: 'member',
              meta: {label: 'メンバー管理'},
              name: 'メンバー',
              component: ChatMember
            },
            {
              path: 'message',
              meta: {label: 'メッセージ'},
              name: 'メッセージ',
              component: ChatMessage
            },
            {
              path: 'history',
              meta: {label: '履歴'},
              name: '履歴',
              component: ChatMessageHistory
            }
          ]
        },
        {
          path: 'routine',
          meta: {label: '個人ルーティン設定'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: RoutineSelf
            },
            {
              path: 'routine',
              meta: {label: '登録・編集'},
              name: '個人ルーティン',
              component: RoutineSelfDetail
            }
          ]
        },
        {
          path: 'services',
          meta: {label: 'サービス'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Services
            },
            {
              path: 'edit',
              meta: {label: '編集'},
              name: '編集',
              component: Service
            },
            {
              path: 'register',
              meta: {label: '登録'},
              name: '登録',
              component: Service
            }
          ]
        },
        {
          path: 'groups',
          meta: {label: 'グループ'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Groups
            },
            {
              path: 'edit',
              meta: {label: '編集'},
              name: 'グループ編集',
              component: Group
            },
            {
              path: 'register',
              meta: {label: '登録'},
              name: 'グループ登録',
              component: Group
            }
          ]
        },
        {
          path: 'profile',
          name: 'プロフィール',
          component: Profile
        },
        {
          path: 'settings',
          name: '設定',
          component: Settings,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'users',
          meta: {label: 'ユーザ'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Users
            },
            {
              path: 'edit',
              meta: {label: '編集'},
              name: 'ユーザ編集',
              component: User
            },
            {
              path: 'register',
              meta: {label: '登録'},
              name: 'ユーザ登録',
              component: User
            }
          ]
        },
        {
          path: 'routines',
          meta: {label: 'ルーティン'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Routines
            },
            {
              path: 'routine',
              meta: {label: 'ルーティン'},
              name: 'ルーティン',
              component: Routine
            },
            {
              path: 'group',
              meta: {label: 'ルーティングループ'},
              name: 'ルーティングループ',
              component: RoutineGroup
            },
            {
              path: 'reference',
              meta: {label: 'ルーティンリファレンス'},
              name: 'ルーティンリファレンス',
              component: RoutineRef
            }
          ]
        }
      ]
    },
    {
      path: '/Terms',
      name: '利用許諾',
      component: TOS
    },
    {
      path: '/Privacy',
      name: 'プライバシーポリシー',
      component: PP
    },
    {
      path: '/login',
      name: 'ログイン',
      component: Login
    },
    {
      path: '/register',
      name: 'ユーザ新規登録',
      component: Register
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js